module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.testimony) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Original Testimony : " + _vm._s(_vm.testimony.purpose ? _vm.testimony.purpose : '-'))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Delete"
    },
    on: {
      "click": _vm.confirm
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony.victimIdentity) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Victim Identity")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block victimIdentity"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.name ? _vm.testimony.victimIdentity.name : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.gender ? _vm.testimony.victimIdentity.gender : '-'))])])]), _vm._v(" "), (_vm.testimony.purpose === 'VICTIM') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Current location")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimLocation && _vm.testimony.victimLocation.otherPlace) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimLocation.otherPlace))]) : (_vm.testimony.victimLocation && _vm.testimony.victimLocation.place) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimLocation.place))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.victimLocation && _vm.testimony.victimLocation.countryName) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Country name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.victimLocation.countryName))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.purpose === 'VICTIM') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Surrounding")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimSurrounding && _vm.testimony.victimSurrounding.people) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimSurrounding.people.join(', ')))]) : (_vm.testimony.victimSurrounding && _vm.testimony.victimSurrounding.otherPeople) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimSurrounding.otherPeople))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.distressLevel) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Distress level")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.distressLevel && _vm.testimony.distressLevel.levels) ? _c('span', [_vm._v(_vm._s(_vm.testimony.distressLevel.levels.join(', ')))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.distressLevel && _vm.testimony.distressLevel.levels && _vm.testimony.distressLevel.levels.includes('ALREADY_ASSISTED')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Assistance description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(!_vm.testimony.distressLevel.alreadyAssistedDescription) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.distressLevel.alreadyAssistedDescription))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.distressLevel) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Psychological state description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.distressLevel.psychologicalStateDescription) ? _c('span', [_vm._v(_vm._s(_vm.testimony.distressLevel.psychologicalStateDescription))]) : _c('span', [_vm._v("-")])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Minor ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.minor ? 'Yes' : _vm.testimony.victimIdentity.minor === false ? 'No' : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._f("age")(_vm.testimony.victimIdentity.birthdate)))]) : _vm._e(), _vm._v(" "), (!_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("-")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Birth date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(new Date(_vm.testimony.victimIdentity.birthdate)))]) : _vm._e(), _vm._v(" "), (!_vm.testimony.victimIdentity.birthdate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("-")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Nationality")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.nationality ? _vm.testimony.victimIdentity.nationality : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Ethnic group")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.ethnicGroup ? _vm.testimony.victimIdentity.ethnicGroup : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Religion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimIdentity.religion ? _vm.testimony.victimIdentity.religion : '-'))])])])]) : _vm._e()])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimIdentity.phoneNumber) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.phoneNumber))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimIdentity.email) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.email))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), (_vm.testimony.victimIdentity.organization) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.organization))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.victimIdentity.publicService) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Public service")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.publicService))])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.victimIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.victimIdentity.contactDescription) ? _c('span', [_vm._v(_vm._s(_vm.testimony.victimIdentity.contactDescription))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.witnessIdentity) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.witnessIdentity) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Witness")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.witnessIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.name ? _vm.testimony.witnessIdentity.name :
    '-'))])])]), _vm._v(" "), (_vm.testimony.purpose === 'THIRDPARTY_WITNESS') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.role ? _vm.testimony.witnessIdentity.role : '-'))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Status / profession")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.status ? _vm.testimony.witnessIdentity.status : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.witnessIdentity.phoneNumber) ? _c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.phoneNumber))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.witnessIdentity.email) ? _c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.email))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), (_vm.testimony.witnessIdentity.organization) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.organization))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.witnessIdentity.publicService) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Public service")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.publicService))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.witnessIdentity.contactDescription) ? _c('span', [_vm._v(_vm._s(_vm.testimony.witnessIdentity.contactDescription))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.witnessIdentity) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Nationality")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.nationality ? _vm.testimony.witnessIdentity.nationality : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Ethnic group")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.ethnicGroup ? _vm.testimony.witnessIdentity.ethnicGroup : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Religion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.witnessIdentity.religion ? _vm.testimony.witnessIdentity.religion : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Close to victim?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(typeof _vm.testimony.witnessIdentity.victimLocationProximity === 'undefined' ?
    '-' :
    _vm.testimony.witnessIdentity.victimLocationProximity ? 'Yes' : 'No'))])])])]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.actionDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.actionDetail) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Attack Details")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.actionDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack types")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.attackTypes ? _vm.testimony.actionDetail.attackTypes.join(', ') : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.attackDescription ? _vm.testimony.actionDetail.attackDescription : '-'))])])]), _vm._v(" "), (_vm.testimony.actionPeriodicity) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack periodicity")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionPeriodicity.periodicity) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionPeriodicity.periodicity.join(', ')))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionPeriodicity) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Attack periodicity details")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionPeriodicity.description) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionPeriodicity.description))]) : _c('span', [_vm._v("-")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionDetail.actionLocation.country) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.country))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Town")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionDetail.actionLocation.town) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.town))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), (_vm.testimony.actionDetail.actionLocation.prison) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Prison")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.prison))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionDetail.actionLocation.camp) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Camp")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.camp))])])])]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionDetail.actionLocation.ownPlace) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Home")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.ownPlace))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Road")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.actionDetail.actionLocation.road) ? _c('span', [_vm._v(_vm._s(_vm.testimony.actionDetail.actionLocation.road))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.actionDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("How many aggressors?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorNumber ? (_vm.testimony.actionDetail.aggressorNumber |
    _vm.prettyNumber) : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor Uniform")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorUniform ? _vm.testimony.actionDetail.aggressorUniform : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor distinctive sign")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorSign ? _vm.testimony.actionDetail.aggressorSign : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor nationality/ethnic group/religion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorAffiliations ? _vm.testimony.actionDetail.aggressorAffiliations : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Aggressor names")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.aggressorNames ? _vm.testimony.actionDetail.aggressorNames : '-'))])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.testimony.victimCondition) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Already assisted?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(typeof _vm.testimony.victimCondition.alreadyHelped === 'undefined' ? '-' :
    _vm.testimony.victimCondition.alreadyHelped ? 'Yes' : 'No'))])])]), _vm._v(" "), (_vm.testimony.victimCondition.helpDescription) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Help description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimCondition.helpDescription))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Need assistance?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(typeof _vm.testimony.victimCondition.helpNeeded === 'undefined' ? '-' :
    _vm.testimony.victimCondition.helpNeeded ? 'Yes' : 'No'))])])]), _vm._v(" "), (_vm.testimony.victimCondition.helpNeededDescription) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Assistance description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.victimCondition.helpNeededDescription))])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Threat Details")]) : _vm._e(), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.threatDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Heard rumor ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.threatDetail.rumor ? 'Yes' : _vm.testimony.threatDetail.rumor === false ? 'No' : '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Bein afraid ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.threatDetail.fear ? 'Yes' : _vm.testimony.threatDetail.fear === false ? 'No' : '-'))])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.testimony.threatDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.actionPeriod && _vm.testimony.actionPeriod.startDate) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Period")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.actionPeriod && _vm.testimony.actionPeriod.startDate) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.testimony.actionPeriod.startDate !== _vm.testimony.actionPeriod.endDate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n                        From " + _vm._s(_vm._f("prettyDate")(_vm.testimony.actionPeriod.startDate)) + " to " + _vm._s(_vm._f("prettyDate")(_vm.testimony.actionPeriod.endDate)) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.testimony.actionPeriod.startDate === _vm.testimony.actionPeriod.endDate) ? _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("prettyDate")(_vm.testimony.actionPeriod.startDate)) + "\n                      ")]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.actionPeriod) ? _c('form', {
    staticClass: "form-horizontal"
  }, [(_vm.testimony.actionPeriod.startDate !== _vm.testimony.actionPeriod.endDate) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Approximate ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionPeriod.exactDate ? 'No' : 'Yes'))])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.crimeDetail) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.testimony.crimeDetail) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("Crime Details")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [(_vm.testimony.crimeDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Any victim?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(typeof _vm.testimony.crimeDetail.anyVictim === 'undefined') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.anyVictim ? 'Yes' : 'No'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Where")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.where) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.where))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("When")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.when) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.when))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("How")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.how) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.how))]) : _c('span', [_vm._v("-")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.testimony.crimeDetail) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Number of victim")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.victimNumber) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.victimNumber))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Profiles of victim")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(_vm.testimony.crimeDetail.victimProfiles) ? _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.victimProfiles.join(', ')))]) : _c('span', [_vm._v("-")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Is witness safe?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(typeof _vm.testimony.crimeDetail.witnessState.isSafe === 'undefined') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.witnessState.isSafe ? 'Yes' : 'No'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Was threatened?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [(typeof _vm.testimony.crimeDetail.witnessState.hasBeenThreatened === 'undefined') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.testimony.crimeDetail.witnessState.hasBeenThreatened ? 'Yes' : 'No'))])])])])]) : _vm._e()])]), _vm._v(" "), (_vm.testimony.actionDetail && _vm.testimony.actionDetail.details) ? _c('span', [_c('h4', {
    staticClass: "subtitle"
  }, [_vm._v("More details")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block details"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.testimony.actionDetail.details))])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Additional data")]), _vm._v(" "), (_vm.testimony && !_vm.editMode) ? _c('i', {
    staticClass: "fa fa-edit clickable pull-right",
    on: {
      "click": _vm.goToEditMode
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony && !_vm.editMode) ? _c('p', [_vm._v(_vm._s(_vm.testimony.comment))]) : _vm._e(), _vm._v(" "), (_vm.testimony && _vm.editMode) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimony.comment),
      expression: "testimony.comment"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.testimony.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.testimony, "comment", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.testimony && _vm.editMode) ? _c('div', {
    staticClass: "box-footer add-data-testimony"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goToReadMode
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.testimony) ? _c('div', [_c('uploader', {
    attrs: {
      "headers": _vm.getToken(),
      "multiple": false,
      "end-point": _vm.getUploadEndpoint()
    },
    on: {
      "fileUploaded": _vm.refresh
    }
  }, [_c('button', {
    attrs: {
      "slot": "browse"
    },
    slot: "browse"
  }, [_vm._v("Add attachments")])]), _vm._v(" "), (_vm.testimony.attachments && _vm.testimony.attachments.length > 0) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.testimony.attachments), function(file) {
    return _c('li', {
      key: file,
      staticClass: "list-group-item list-group-item-action"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }), _vm._v(" "), _c('a', {
      staticClass: "file-name",
      attrs: {
        "href": _vm.getUrl(file)
      }
    }, [_vm._v(_vm._s(file))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash clickable pull-right",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeleteFile(file)
        }
      }
    }), _vm._v(" "), _c('file-previewer', {
      attrs: {
        "id": _vm.id,
        "name": file,
        "source": _vm.getUrl(file)
      }
    })], 1)
  }), 0) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony.recordings && _vm.testimony.recordings.length > 0) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.testimony.recordings), function(recording) {
    return _c('li', {
      key: recording,
      staticClass: "list-group-item list-group-item-action"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }), _vm._v(" "), _c('a', {
      staticClass: "file-name",
      attrs: {
        "href": _vm.getRecordingUrl(recording)
      }
    }, [_vm._v(_vm._s(recording))]), _vm._v(" "), _c('audio', {
      attrs: {
        "controls": "",
        "controlsList": "nodownload"
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.getRecordingUrl(recording),
        "type": "audio/webm"
      }
    })])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony) ? _c('osm-map', {
    attrs: {
      "markers": [_vm.testimonyMarker]
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimony) ? _c('injuries', {
    attrs: {
      "victimCondition": _vm.testimony.victimCondition
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.testimony) ? _c('signaletics', {
    attrs: {
      "id": _vm.id,
      "status": _vm.testimony.status,
      "type": "testimonies"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Related Cases")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-link clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Link"
    },
    on: {
      "click": _vm.openLinkModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    class: {
      'no-padding': _vm.cases.length > 0
    }
  }, [(_vm.cases.length == 0) ? _c('p', [_vm._v("No related case")]) : _vm._e(), _vm._v(" "), (_vm.cases.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table relative-case-table table-bordered table-striped no-margin",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.cases), function(relatedCase) {
    return _c('tr', {
      staticClass: "even clickable",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.goToCase(relatedCase)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(relatedCase.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("prettyDateTime")(relatedCase.creationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(relatedCase.status))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-close clickable",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "Detach Case"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.confirmRemoveLink(relatedCase._id)
        }
      }
    })])])
  }), 0)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.testimony && _vm.testimony.version) ? _c('anchors', {
    attrs: {
      "id": _vm.id,
      "type": "testimonies",
      "anchorDone": "refresh",
      "version": _vm.testimony.version
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('label', [_vm._v("Type : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo ? _vm.testimony.originInfo.origin : "UNKNOWN"))]), _vm._v(" "), (_vm.testimony.originInfo && _vm.testimony.originInfo.version) ? _c('p', [_c('label', [_vm._v("Form version : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo.version))]) : _vm._e(), _vm._v(" "), (_vm.testimony.originInfo && _vm.testimony.originInfo.originId) ? _c('p', [_c('label', [_vm._v("Platform ID : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo.originId))]) : _vm._e(), _vm._v(" "), (_vm.testimony.originInfo && _vm.testimony.originInfo.originalCode) ? _c('p', [_c('label', [_vm._v("Original Code : ")]), _vm._v(" " + _vm._s(_vm.testimony.originInfo.originalCode) + " ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('label', [_vm._v("Web Code : ")]), _vm._v(" " + _vm._s(_vm.testimony.randomId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    class: {
      'no-padding': _vm.similars.length > 0
    }
  }, [(!_vm.similars || _vm.similars.length == 0) ? _c('p', [_vm._v("No similar testimony")]) : _vm._e(), _vm._v(" "), (_vm.similars && _vm.similars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped no-margin",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.similars), function(similar) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [(similar && similar.actionDetail && similar.actionDetail.actionLocation) ? _c('span', [_vm._v("\n                          " + _vm._s(similar.actionDetail.actionLocation.zone) + "\n                          ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("prettyDateTime")(similar.creationDate)))]), _vm._v(" "), _c('td', [(similar.victimIdentity) ? _c('span', [_vm._v("\n                            " + _vm._s(similar.victimIdentity.firstName) + " " + _vm._s(similar.victimIdentity.name) + "\n                          ")]) : _vm._e()])])
  }), 0)])])]) : _vm._e()])])]), _vm._v(" "), (_vm.testimony && _vm.testimony.actionPeriod && _vm.testimony.actionPeriod.startDate && _vm.testimonyMarker) ? _c('div', {
    staticClass: "row"
  }, [_c('automatic-data', {
    attrs: {
      "testimonyLocation": _vm.testimonyMarker.coordinates,
      "testimonyTime": _vm.getStartTime()
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to archive this testimony ?",
      "title": "Archive Confirmation",
      "id": "ConfirmModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.archive()
      }
    }
  }), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to detach this testimony to that case ?",
      "title": "Detach Confirmation",
      "id": "ConfirmLinkModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.removeLink()
      }
    }
  }), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to delete this attachment ?",
      "title": "Delete Confirmation",
      "id": "ConfirmDeleteFileModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.deleteFile()
      }
    }
  }), _vm._v(" "), _c('link-case-modal', {
    ref: "linkCaseModal",
    attrs: {
      "id": "LinkCaseModal",
      "preselected": _vm.cases
    },
    on: {
      "link": _vm.linkAll
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-offset-1 col-md-5"
  }, [_c('div', {
    staticClass: "form-horizontal form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label"
  }, [_vm._v("Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Recordings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Location where testimony was saved")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Body injuries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Name\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Creation Date\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Status\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Origin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Similar Testimonies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Location\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Creation Date\n                      ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("\n                        Name\n                      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1acd2ef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Testimony.vue
// module id = 430
// module chunks = 1